module.exports = __webpack_public_path__ + "img/en_right.64efd485.png";